<template>
  <div class="basic_wrap password-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('setpwd.modifyLoginPassword') }}
      </div>
    </div>

    <div class="form-card">
      <div class="write_box">
        <input
          v-model="password"
          :type="passwordInp"
          :placeholder="$t('setpwd.originalloginpassword')"
        >
        <button
          type="button"
          class="eye_bi"
          :class="passwordInp == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>

      <div class="write_box">
        <input
          v-model="npassword"
          :type="newpasswordInp"
          :placeholder="$t('setpwd.newpassword')"
        >
        <button
          type="button"
          class="eye_bi"
          :class="newpasswordInp == 'text' ? 'eye' : ''"
          @click="showNewsPwd"
        />
      </div>

      <div class="write_box">
        <input
          v-model="rpassword"
          :type="newpasswordInp"
          :placeholder="$t('setpwd.confirmnewpassword')"
        >
        <button
          type="button"
          class="eye_bi"
          :class="newpasswordInp == 'text' ? 'eye' : ''"
          @click="showNewsPwd"
        />
      </div>
    </div>

    <button
      v-if="codeStatus"
      type="button"
      class="basic_btn"
      :class="rpassword != '' && code != '' && npassword != '' ? '' : 'no_touch'"
      @click="dxRevise"
    >
      {{ $t('setpwd.modify') }}
    </button>
    <button
      v-if="!codeStatus"
      type="button"
      class="basic_btn"
      :class="password != '' && rpassword != '' && npassword != '' ? '' : 'no_touch'"
      @click="oldRevise"
    >
      {{ $t('setpwd.modify') }}
    </button>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";

export default {
	name: "Setpwd",
	data() {
		return {
			time: 0,
			oldpwd: "",
			password: "",
			rpassword: "",
			npassword: "",
			mobile: "",
			ycmobile: "",
			passwordInp: "password",
			newpasswordInp: "password",
			codeStatus: false,
			codeOK: false,
			code: "",
			is_send: false,
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		Fetch("/user/info").then(r => {
			this.mobile = r.data.mobile;
			this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
		});
	},
	methods: {
		cutType(n) {
			this.codeStatus = n == 1;
			this.rpassword = "";
			this.npassword = "";
		},
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		sendcode() {
			if (this.is_send) {
				return;
			}
			this.is_send = true;
			Fetch("/index/forgetpwd_email_code", {}).then(() => {
				this.time = 120 * 1000;
				this.$toast({
					background: "#07c160",
					message: this.$t("setpwd.sendsuccessfully"),
				});
			}).catch(() => {
				this.is_send = false;
			});
		},
		showPwd() {
			this.passwordInp = this.passwordInp == "password" ? "text" : "password";
		},
		showNewsPwd() {
			this.newpasswordInp = this.newpasswordInp == "password" ? "text" : "password";
		},
		dxRevise() {
			if (!this.npassword) {
				this.$toast(this.$t("setpwd.newpasswordcannotbeempty"));
				return false;
			}

			if (this.npassword !== this.rpassword) {
				this.$toast(this.$t("setpwd.inconsistent"));
				return false;
			}

			Fetch("/index/forgetpwd", {
				code: this.code,
				password: this.npassword,
			}).then(() => {
				this.$toast({
					background: "#07c160",
					message: this.$t("setpwd.modifiedsuccessfully"),
				});

				this.$router.replace("/set");
			});
		},
		oldRevise() {
			if (!this.password) {
				this.$toast(this.$t("setpwd.originalpasswordcannotbeempty"));
				return false;
			}
			if (!this.npassword) {
				this.$toast(this.$t("setpwd.newpasswordcannotbeempty"));
				return false;
			}
			if (this.npassword !== this.rpassword) {
				this.$toast(this.$t("setpwd.inconsistent"));
				return false;
			}
			Fetch("/user/repasswd", {
				passwd: this.password,
				npasswd: this.npassword,
			}).then(() => {
				this.$toast({
					background: "#07c160",
					message: this.$t("setpwd.modifiedsuccessfully"),
				});
				this.$router.replace("/set");
			});
		},
	},
};
</script>

<style lang="less" scoped>
.password-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 88px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		// filter: invert(1);
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.form-card {
	margin: 16px 16px 0;
	padding: 4px 16px 18px;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.write_box {
	width: 100%;
	height: 46px;
	margin-top: 14px;
	padding: 0 12px;
	display: flex;
	align-items: center;
	border-radius: 10px;
	border: 1px solid rgba(255, 93, 122, 0.32);
	background: #fff6f8;
	box-sizing: border-box;
}

.write_box input {
	min-width: 0;
	flex: 1;
	height: 22px;
	border: 0;
	background: transparent;
	color: #16223a;
	font-size: 14px;
	line-height: 22px;
	outline: none;
}

.write_box input::placeholder {
	color: #727d91;
}

.write_box:focus-within {
	border-color: rgba(255, 93, 122, 0.52);
	box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
}

.write_box input:-webkit-autofill,
.write_box input:-webkit-autofill:hover,
.write_box input:-webkit-autofill:focus {
	-webkit-text-fill-color: #16223a;
	box-shadow: 0 0 0 1000px #fff6f8 inset;
	caret-color: #ff5d7a;
}

.eye_bi {
	width: 24px;
	height: 28px;
	flex: 0 0 24px;
	margin-left: 10px;
	border: 0;
	background: url(../images/user/eye2.png) no-repeat center center;
	background-size: 21px auto;
	filter: invert(1);
	opacity: 0.72;
	padding: 0;
}

.eye_bi.eye {
	background-image: url(../images/user/eye1.png);
}

.basic_btn {
	width: calc(100% - 32px);
	height: 46px;
	margin: 24px 16px 0;
	border: 1px solid rgba(255, 93, 122, 0.42);
	border-radius: 10px;
	background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.basic_btn.no_touch {
	pointer-events: none;
	opacity: 0.46;
}

@media screen and (max-width: 374px) {
	.form-card {
		margin-right: 12px;
		margin-left: 12px;
		padding-right: 14px;
		padding-left: 14px;
	}

	.basic_btn {
		width: calc(100% - 24px);
		margin-right: 12px;
		margin-left: 12px;
	}
}
</style>
